import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.333 4h3.333v1.333h-1.333V14a.666.666 0 0 1-.667.667H3.333A.667.667 0 0 1 2.666 14V5.333H1.333V4h3.333V2a.667.667 0 0 1 .667-.667h5.333a.666.666 0 0 1 .667.667zM12 5.333H4v8h8zM6 2.667V4h4V2.667z"
    }, null, -1)
  ]))]))
}
export default { render: render }